const translations = {
    actionsLabel: 'Invitation actions',
    delete: 'Delete',
    deleteConfirmCancel: 'Keep invitation',
    deleteConfirmLabel: 'Delete invitation',
    deleteConfirmMessage: 'This invitation will no longer be valid.',
    deleteConfirmTitle: 'Delete this invitation?',
    email: 'Email',
    emptyDescription: 'Invite a teammate to see the invitation listed here.',
    emptyHeading: 'No pending invitations',
    expires: 'Expires',
    loadMore: 'Load more',
    resend: 'Resend',
    role: 'Role',
    sent: 'Sent',
    status: 'Status',
    tableLabel: 'Invitations'
};

export default translations;
